import { createApp } from 'vue'
import LabApp from './LabApp.vue'
import router from './router'
import { configureClient } from '@/hexapla-core/client'
import { session, signOut } from './session'

// A 401 means the session ended (expired, or replaced by a sign-in elsewhere).
configureClient(
  () => session.token,
  () => {
    signOut()
    if (router.currentRoute.value.path !== '/login') router.push('/login')
  }
)

createApp(LabApp).use(router).mount('#app')
